import React, { useContext, useEffect, useState } from "react";
import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  InputCheckboxMaster,
  Loading,
  MasterButton,
  Modal,
} from "App/Component/ui";
import {
  headCells,
  RenderStatusKebutuhanBadge,
  RenderStatusVerifikasiBadge,
  RESET_STATE_FORM_FILTER,
} from "../../DaftarRequestFixedAsset/helpers";
import { getByFilterReq } from "../../PengajuanRequest/helpers";

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@material-ui/core";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import {
  defaultDateDisplay,
  defaultToastError,
  isNull,
} from "App/utils/helpers";
import { STYLE_DEFAULT_MASTER } from "App/constants";
import FormFilterDaftarRequest from "../../DaftarRequestFixedAsset/FormFilterDaftarREQ";
import { FormContext } from "../context/FormContext";
import {
  getReqListById,
  STATUS_BARANG_OK,
  STATUS_BARANG_PENGAJUAN,
  STATUS_BARANG_TOLAK,
} from "../../RequestFixedAsset/helpers";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { AddIcon } from "App/Assets";
import TableHeader from "App/Component/ui/datatable/TableHeader";

function ModalListRequest({
  setShowModal,
  handleClickSelect,
  alwaysPengadaan = false,
}) {
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [totalData, setTotalData] = useState(0);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeRow, setActiveRow] = useState({
    index: null,
    id: null,
    unit_id: null,
    unit: null,
  });
  const { rowsBarang, setRowsBarang, rowsSelect, setRowsSelect } =
    useContext(FormContext);

  const classes = STYLE_DEFAULT_MASTER();

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getByFilterReq(formFilter, pages, limit, false, true, '/wmsAsset/request/list-pengajuan-request-po', 3);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const setNewDataReq = async () => {
    if (!isNull(activeRow.id)) {
      setRowsBarang("Sedang Mengambil Data...");
      const res = await getReqListById(activeRow.id, 3);
      if (res.state) {
        setRowsSelect([]);
        setRowsBarang(res.data);
      } else {
        setRowsBarang([]);
      }
    }
  };

  const handleClickSimpan = async () => {
    if (rowsSelect.length === 0) {
      defaultToastError("Harap pilih barang terlebih dahulu !");
    } else {
      handleClickSelect(activeRow);
      setShowModal(false);
    }
  };

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    (async () => {
      await setNewDataReq();
    })();
  }, [activeRow.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  const handleClickReset = () => {
    setRowsSelect([]);
  };

  return (
    <>
      <Modal title="Pilih Request Fixed Asset" show={setShowModal} width="90%">
        <Paper
          style={{
            padding: "1rem",
          }}
        >
          <FormFilterDaftarRequest
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
          />
          <Loading show={loading} />
          {/* <TableDaftarRequest
            rows={rows}
            classes={classes}
            onlySelect={true}
            handleClickSelect={handleClickSelect}
          /> */}
          <TableContainer className="custom-scrollbar">
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={"medium"}
              aria-label="enhanced table"
            >
              <TableHeader
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={length}
                headCells={headCells}
              />
              <TableBody>
                {stableSort(rows, getComparator(order, orderBy)).map(
                  (row, index) => {
                    return (
                      <>
                        <TableRow
                          hover
                          tabIndex={-1}
                          key={index}
                          // style={{
                          //   backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                          // }}
                        >
                          <TableCell
                            component="th"
                            scope="row"
                            padding="none"
                            align="center"
                          >
                            <IconButtonDatatable
                              color="secondary"
                              onClick={() => {
                                if (activeRow.index === index) {
                                  setActiveRow({
                                    id: null,
                                    index: null,
                                    unit_id: null,
                                    unit: null,
                                  });
                                } else {
                                  setActiveRow({
                                    id: row.id,
                                    unit_id: row?.unit_id,
                                    unit: row?.unit,
                                    index: index,
                                  });
                                }
                              }}
                            >
                              <AddIcon />
                            </IconButtonDatatable>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            padding="none"
                            align="center"
                          >
                            {index + 1}
                          </TableCell>

                          <TableCell align="left">{row?.id}</TableCell>
                          <TableCell align="left">{row?.name}</TableCell>
                          <TableCell align="left">{row?.unit}</TableCell>
                          <TableCell align="left">
                            <RenderStatusKebutuhanBadge
                              status={row.status_kebutuhan}
                            />
                          </TableCell>
                          <TableCell align="left">
                            {row?.user_request}
                          </TableCell>
                          <TableCell align="left">
                            {row.jml_req_barang}
                          </TableCell>
                          <TableCell align="left">
                            <RenderStatusVerifikasiBadge
                              status={row?.status_verifikasi}
                            />
                          </TableCell>
                          <TableCell align="left">
                            {isNull(row?.remark) ? null : row?.remark}
                          </TableCell>
                          <TableCell align="left">
                            {isNull(row?.tanggal_verifikasi)
                              ? "-"
                              : defaultDateDisplay(row?.tanggal_verifikasi)}
                          </TableCell>
                          <TableCell align="left">
                            {isNull(row?.user_verifikasi)
                              ? "-"
                              : row?.user_verifikasi}
                          </TableCell>
                          <TableCell align="left">
                            {isNull(row?.remak_verifikasi)
                              ? "-"
                              : row?.remak_verifikasi}
                          </TableCell>
                          <TableCell align="left">
                            {defaultDateDisplay(row?.tgl_permintaan)}
                          </TableCell>
                          <TableCell align="left">
                            {defaultDateDisplay(row?.createdAt)}
                          </TableCell>
                          <TableCell align="left">{row?.createdBy}</TableCell>
                          <TableCell align="left">
                            {defaultDateDisplay(row?.updatedAt)}
                          </TableCell>
                          <TableCell align="left">{row?.updatedBy}</TableCell>
                        </TableRow>
                        {activeRow.index === index && (
                          <>
                            <TableHeadDafarBarang index={index} />
                            <TableListBarang
                              rowsBarang={rowsBarang}
                              handleClickSelect={handleClickSelect}
                              rowsSelect={rowsSelect}
                              setRowsSelect={setRowsSelect}
                              row={row}
                            />
                          </>
                        )}
                      </>
                    );
                  }
                )}
                {rows.length === 0 && (
                  <TableRow>
                    <TableCell align="center" colSpan={headCells.length}>
                      Tidak ada data
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
            }}
          >
            <MasterButton
              color="danger"
              type="button"
              name="RESET"
              onClick={handleClickReset}
              size="xl"
              style={{
                padding: "0.5rem 1rem",
                textAlign: "center",
              }}
            />
            <MasterButton
              color={loading ? "secondary" : "green"}
              type="button"
              name={loading ? "Loading.." : "SIMPAN"}
              disabled={loading}
              onClick={handleClickSimpan}
              size="xl"
              style={{
                padding: "0.5rem 1rem",
                textAlign: "center",
              }}
            />
          </div>
        </Paper>
      </Modal>
    </>
  );
}

const TableHeadDafarBarang = ({ index }) => {
  return (
    <>
      <TableRow
        hover
        tabIndex={-1}
        key={index}
        style={{
          backgroundColor: "#fff",
        }}
      >
        <TableCell component="th" align="left"></TableCell>
        <TableCell
          component="th"
          scope="row"
          padding="none"
          align="left"
          style={{
            padding: "1.5rem",
          }}
        >
          ACT
        </TableCell>

        <TableCell component="th" align="left">
          ID
        </TableCell>

        <TableCell component="th" align="left" style={{ minWidth: "200px" }}>
          NAMA BARANG
        </TableCell>

        <TableCell component="th" align="left">
          KATEGORI
        </TableCell>

        <TableCell component="th" align="left">
          SATUAN
        </TableCell>

        <TableCell component="th" align="left">
          QTY
        </TableCell>

        <TableCell component="th" align="left" colSpan="2">
          CATATAN
        </TableCell>

        <TableCell component="th" align="left">
          STATUS
        </TableCell>

        <TableCell component="th" align="left" colSpan="2">
          KETERANGAN
        </TableCell>
      </TableRow>
    </>
  );
};

const TableListBarang = ({
  rowsBarang,
  handleClickSelect,
  row,
  rowsSelect,
  setRowsSelect,
}) => {
  const handleClickSingleSelect = (row) => {
    const filter = rowsSelect.filter((item) => item.id === row.id);
    if (filter.length > 0) {
      const filterExcept = rowsSelect.filter((item) => item.id !== row.id);
      setRowsSelect(filterExcept);
    } else {
      setRowsSelect([...rowsSelect, row]);
    }
  };

  const checkAlready = (id) => {
    const filter = rowsSelect.filter((item) => item.id === id);
    return filter.length > 0 ? true : false;
  };
  return (
    <>
      {Array.isArray(rowsBarang) ? (
        rowsBarang.map((item, index) => {
          return (
            <>
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: "#f3f3f3",
                }}
              >
                <TableCell align="left">{""}</TableCell>
                <TableCell>
                  {parseInt(item?.kategori) === 3 ? (
                    <>
                      <InputCheckboxMaster
                        name="status"
                        onClick={(e) => handleClickSingleSelect(item)}
                        checked={checkAlready(item.id)}
                        disabled={false}
                        id="status"
                        label=""
                        style={{
                          marginTop: "-8px",
                          width: "31px",
                          height: "22px",
                        }}
                        endContent={true}
                      />
                    </>
                  ) : (
                    <>
                      <InputCheckboxMaster
                        name="status"
                        checked={checkAlready(item.id)}
                        disabled={true}
                        id="status"
                        label=""
                        style={{
                          marginTop: "-8px",
                          width: "31px",
                          height: "22px",
                        }}
                        endContent={true}
                      />
                    </>
                  )}

                  {/* <TableAction
                    isUpdate={false}
                    isDelete={false}
                    isSelect={false}
                    isDisabledCheck={false}
                    isCheck={true}
                    clickCheck={(e) => handleClickSingleSelect(item)}
                    checked={checkAlready(item.id)}
                  /> */}
                </TableCell>
                <TableCell align="left">{item?.id}</TableCell>
                <TableCell align="left">{item?.name_barang}</TableCell>
                <TableCell align="left">
                  {isNull(item?.kategori)
                    ? "-"
                    : item?.kategori === 1
                    ? "Perbekalan Farmasi"
                    : item?.kategori === 2
                    ? "Logisitik"
                    : "Fixed Asset"}
                </TableCell>
                <TableCell align="left">{item?.namasatuan}</TableCell>
                <TableCell align="left">{item.qty}</TableCell>
                {/* <TableCell align="left">{item?.namagolongan}</TableCell> */}
                <TableCell align="left" colSpan="2">
                  {isNull(item?.remark) ? "-" : item?.remark}
                </TableCell>
                <TableCell align="left">
                  <RenderStatusVerifikasiBadgeBarang
                    status={item?.status_cek_barang}
                  />
                </TableCell>
                <TableCell align="left" colSpan="2">
                  {item?.keterangan_cek_barang === null
                    ? "-"
                    : item?.keterangan_cek_barang}
                </TableCell>
              </TableRow>
            </>
          );
        })
      ) : (
        <TableRow hover tabIndex={-1}>
          <TableCell component="th" align="center" colSpan="11">
            {rowsBarang}
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

const RenderStatusVerifikasiBadgeBarang = ({ status }) => {
  // eslint-disable-line
  if (status === STATUS_BARANG_PENGAJUAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PENGAJUAN"}
        color={"secondary"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_BARANG_OK) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"OK"}
        color={"green"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_BARANG_TOLAK) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"Ditolak"}
        color={"danger"}
        type="button"
        disabled
      />
    );
  } else {
    return <p>-</p>;
  }
};

export default ModalListRequest;
